module.exports = __webpack_public_path__ + "static/media/6635.a72a6359.jpg";